export default __webpack_public_path__ + "static/media/face_3_16.d4163c43.png";